
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Group from 'vux/src/components/group/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import FormPreview from 'vux/src/components/form-preview/index.vue'

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import XHeader from 'vux/src/components/x-header/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
components: {
Tab,
TabItem,
Divider,
XButton,
Group,
FormPreview,
Flexbox,
FlexboxItem,
InfiniteLoading,
XHeader
},

data() {
return {
noticeStr: '',
currentUser: 0,
orderList: {
new_order: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
sent_order: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
all: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
btnShowLoading: '',
orderType:'new_order'
}
};
},
computed: {
isShowLoadMoreBtn() {
return this.orderList[this.currentUser]['total'] >= this.orderList[this.currentUser]['currentPage'] * this.orderList[this.currentUser]['perPage']
}
},
created: function () {
document.title = '订单列表'
this.currentUser = 'new_order';
},

methods: {
infiniteHandler($state) {
const url = this.tianYiWebUrl + '/wechat/admin/orderListByType';
this.btnShowLoading = true;
this.$http.get(url, {
params: {
type: this.currentUser,
page: this.orderList[this.currentUser]['currentPage']
}
}).then(r => {
let res = r.data;
if (res.code === 200) {
let vRes = res.data;
this.noticeStr = res.extra;
this.orderList[this.currentUser]['list'] = [... this.orderList[this.currentUser]['list'], ...res.data.data];
this.orderList[this.currentUser].currentPage = +res.data.current_page + 1;
if (vRes.total > vRes.per_page * vRes.current_page) {
this.orderList[this.currentUser]['perPage'] = res.data.per_page;
this.orderList[this.currentUser]['total'] = res.data.total;
this.btnShowLoading = false;
$state.loaded();
} else {
this.orderList[this.currentUser]['end'] = 1
$state.complete();
}
}
})
},
handleChange(i) {
this.currentUser = i === 0 ? 'new_order' :
(i === 1 ? 'sent_order' :
(i === 2 ? 'all' : ''));
if (this.orderList[this.currentUser]['total'] === 0
|| this.orderList[this.currentUser]['end'] === 0) {
this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/AdminOrderList.vue